import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { DialogService } from '../../../dialog/dialog.service';
import { Document } from '../../../document-data/document.model';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { GlobalBannerService } from '../../../shared/components/global-banner/global-banner.service';
import { ToasterDispatcher } from '../../../toaster/toaster.dispatcher';
import { XeroAccount } from '../../../xero-data/xero-account.model';
import { XeroDataDispatcher } from '../../../xero-data/xero-data.dispatcher';

@Component({
  selector: 'app-export-xero-action',
  templateUrl: './export-xero-action.component.html',
  styleUrls: ['./export-xero-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportXeroActionComponent implements OnChanges, OnInit, OnDestroy {
  @Input() document: Document;
  @Input() toggles: Toggles;
  @Input() xeroAccount: XeroAccount;

  @Output() onExportXero: EventEmitter<void> = new EventEmitter<void>();

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  xeroPermission: boolean;

  constructor(
    private _dialogService: DialogService,
    private _toasterDispatcher: ToasterDispatcher,
    private _translateService: TranslateService,
    private _globalBannerService: GlobalBannerService,
    private _xeroDataDispatcher: XeroDataDispatcher
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.toggles && this.toggles) {
      this.xeroPermission = this.toggles.isAllAccess(Toggles.KEYS.XERO);
    }
  }

  ngOnInit() {}

  exportToXero() {
    this._xeroDataDispatcher.exportDocumentToXero(
      this.document.id,
      this.document.docNumber
    );
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
